module.exports = __webpack_public_path__ + "static/img/admin.15513a1b.png";